module.exports = __webpack_public_path__ + "static/media/3.c5036fb4.png";